import React, { useEffect, useState, useRef } from "react";
import PageTitle from "../../../module/pageTitle";
import AdminTable from "../../../Component/adminTable";
import LabelInput from "../../../Component/labelInput";
import { InputField, Submitbtn } from "../../../Component";
import AddMoreBtn from "../../../Component/addMoreBtn";
import TextEditor from "../../../Component/textEditor";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import EditIcon from "@mui/icons-material/Edit";
import {
  deleteProduct,
  getAgeGroupList,
  getCategoryList,
  getGSTList,
  getLanguageList,
  getProductById,
  getProductList,
  getProductTypeList,
  getTagOptionList,
  updateProduct,
  getSellingSource,
  uploadMedia,
  booksAnswerkeyUpload,
} from "../adminSlice";
import { AppDispatch } from "../../../store";
import { useDispatch } from "react-redux";
import {
  containsNumber,
  length_Four,
  length_Thirteen,
  validateAgeGrp,
  validateDimension,
  validateIsFileImageType,
  validateIsFileVideoType,
  validateValueWithoutSpace,
} from "../../../Utils/validators";
import {
  validateIsFileImageTypeErrMsg,
  validateIsFileVideoTypeErrMsg,
  validateIsNumberOnlyErrMsg,
} from "../../../Utils/errorMsg";
import ImgPickerAndViewer from "../../../Component/imgPickerAndViewer";
import DropdownWithClear from "../../../Component/dropdownWithClear";
import {
  showSnackbar,
  hideSnackbar,
} from "../../../store/slices/snackbarSlice";
import ImagePickerAndViewer from "../../../Component/imagePickerAndViewer";
import DownloadIcon from "@mui/icons-material/Download";
import { Tooltip } from "@mui/material";

const EditDeleteProduct = () => {
  const dispatch = useDispatch<AppDispatch>();
  const initialVal = [
    {
      value: "",
    },
  ];
  const [productList, setProductList] = useState<any>([]);
  const [imgVideoArr, setimgVideoArr] = useState<any>(initialVal);
  const [isEditMode, setisEditMode] = useState<Boolean>(false);
  const [productTypeList, setProductTypeList] = useState<any>([]);
  const [productType, setProductType] = useState<any>("");
  const [categoryList, setCategoryList] = useState<any>([]);
  const [category, setCategory] = useState<any>("");
  const [productName, setProductName] = useState<any>("");
  const [initialAge, setInitialAge] = useState<any>("");
  const [ageGroupList, setAgeGroupList] = useState<any>([]);
  const [ageGroup, setAgeGroup] = useState<any>("");
  const [sellingPrice, setSellingPrice] = useState<any>("");
  const [offerPrice, setOfferPrice] = useState<any>("");
  const [stockReminder, setStockReminder] = useState<any>("");
  const [isbnNo, setisbnNo] = useState<any>("");
  const [uniqueNo, setUniqueNo] = useState<any>("");
  const [isEditingIsbn, setIsEditingIsbn] = useState<boolean>(false);
  const [briefDesc, setBriefDesc] = useState<any>("");
  const [productDesc, setProductDesc] = useState<any>("");
  const [additionInfo, setAdditionInfo] = useState<any>("");
  const [languageList, setLanguageList] = useState<any>([]);
  const [language, setLanguage] = useState<any>();
  const [diamension, setdiamension] = useState<any>("");
  const [totalpages, settotalpages] = useState<any>("");
  const [isTaxable, setisTaxable] = useState<boolean>(false);
  const [GSTList, setGSTList] = useState<any>([]);
  const [GSTPercentage, setGSTPercentage] = useState<any>("");
  const [tagOptionList, setTagOptionList] = useState<any>([]);
  const [newTagArr, setNewTagArr] = useState<any>([]);
  const [video, setVideo] = useState<any>("");
  const [videoPreview, setVideoPreview] = useState<any>("");
  const [categoryFilter, setCategoryFilter] = useState<any>("");
  const [productTypeFilter, setProductTypeFilter] = useState<any>("");
  const [productId, setProductId] = useState<any>("");
  const [productData, setProductData] = useState<any>("");
  const [sellingSource, setSellingSource] = useState<any>([]);
  const [sellingSourceCopy, setSellingSourceCopy] = useState<any>([]);
  const [allCheck, setAllCheck] = useState(false);
  const [sourcePrice, setSourcePrice] = useState("");
  const [buyTogaterProductList, setBuyTogaterProductList] = useState<any>([]);
  const [buyTogatherProduct, setBuyTogatherProduct] = useState<any>("");
  const [selectedBuyProduct, setSelectedBuyProduct] = useState<any>([]);
  const [answerKeyURL, setAnswerKeyURL] = useState<any>("");
  const initialValDescImg = [
    {
      image: "",
      order: "",
      text: "",
      type: 1,
      imagePreview: "",
    },
  ];
  const [descriptionImages, setdescriptionImages] =
    useState<any>(initialValDescImg);

  useEffect(() => {
    getData();
    dispatch(
      getProductTypeList({
        callback: (res: any) => {
          setProductTypeList(res?.data);
        },
        errorCallback: () => { },
      }),
    );

    dispatch(
      getTagOptionList({
        callback: (res: any) => {
          setTagOptionList(res?.data);
        },
        errorCallback: () => { },
      }),
    );
    dispatch(
      getAgeGroupList({
        callback: (res: any) => {
          setAgeGroupList(res?.data);
        },
        errorCallback: () => { },
      }),
    );
    dispatch(
      getLanguageList({
        callback: (res: any) => {
          setLanguageList(res?.data);
        },
        errorCallback: () => { },
      }),
    );
    dispatch(
      getGSTList({
        callback: (res: any) => {
          setGSTList(res?.data);
        },
        errorCallback: () => { },
      }),
    );
    dispatch(
      getSellingSource({
        callback: (sourceRes: any) => {
          const baseList =
            sourceRes?.data?.map((item: any) => ({
              _id: item?._id,
              name: item?.name,
              price: "",
              isChecked: false,
            })) || [];
          setSellingSource(baseList);
        },
        errorCallback: () => { },
      }),
    );
  }, []);
  const videoRef = useRef<HTMLVideoElement | null>(null);
  const productVideoRef = useRef<HTMLVideoElement | null>(null);

  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.load();
    }
  }, [imgVideoArr]);

  useEffect(() => {
    if (productVideoRef.current) {
      productVideoRef.current.load();
    }
  }, [videoPreview]);
  const onchangeImgVideo = (value: any, index: any, key: any, doctype: any) => {
    const newArray = [...imgVideoArr];
    if (key === "url") {
      if (doctype === "image") {
        if (!validateIsFileImageType(value)) {
          return;
        } else {
          const reader = new FileReader();
          const file = value.target.files[0];
          reader.onloadend = () => {
            newArray[index]["imagePrevUrl"] = reader.result;
            setimgVideoArr(newArray);
          };
          reader.readAsDataURL(file);
          const imagePayload = {
            file: file,
            type: "product",
            format: "1",
          };
          dispatch(
            uploadMedia({
              params: imagePayload,
              callback: (res: any) => {
                if (res?.data) {
                  newArray[index][key] = res?.data?.name;
                  setimgVideoArr(newArray);
                }
              },
              errorCallback: () => { },
            }),
          );
        }
      } else if (doctype === "video") {
        if (!validateIsFileVideoType(value)) {
          return;
        } else {
          const reader = new FileReader();
          const file = value.target.files[0];
          reader.onloadend = () => {
            newArray[index]["imagePrevUrl"] = reader.result;
            setimgVideoArr(newArray);
          };
          reader.readAsDataURL(file);
          const imagePayload = {
            file: file,
            type: "product",
            format: "2",
          };
          dispatch(
            uploadMedia({
              params: imagePayload,
              callback: (res: any) => {
                if (res) {
                  newArray[index][key] = res?.data?.name;
                  setimgVideoArr(newArray);
                }
              },
              errorCallback: () => { },
            }),
          );
        }
      }
    } else if (key === "order") {
      if (validateAgeGrp(value)) {
        newArray[index][key] = value;
        setimgVideoArr(newArray);
      }
      // newArray[index][key] = parseInt(value);
    } else if (key === "type") {
      const newType = parseInt(value);
      if (newArray[index].type !== newType) {
        newArray[index].url = "";
        newArray[index].type = newType;
        setimgVideoArr(newArray);
      }
    }
  };

  const changeCheckBox = (event: any, index: any) => {
    let newArray = JSON.parse(JSON.stringify(tagOptionList));
    if (event.target.checked) {
      newArray[index]["isSelected"] = true;
      setNewTagArr((prev: any) => [...prev, event.target.id]);
    } else {
      newArray[index]["isSelected"] = false;
      setNewTagArr((prev: any) =>
        prev.filter((id: any) => id !== event.target.id),
      );
    }
    setTagOptionList(newArray);
  };
  const getData = () => {
    const postData = {};
    dispatch(
      getProductList({
        params: postData,
        callback: (res: any) => {
          setProductList(res);
        },
        errorCallback: (error: any) => { },
      }),
    );
  };

  const handleEdit = (value: any) => {
    setisEditMode(true);
    setNewTagArr([]);
    setIsEditingIsbn(false);
    setAllCheck(false);
    setSourcePrice("");
    dispatch(
      getProductById({
        id: value?._id,
        callback: (res: any) => {
          if (res?.data?.status === "success") {
            dispatch(
              showSnackbar({
                message: res?.data?.msg,
                type: res?.data?.status,
              }),
            );
            setTimeout(() => {
              dispatch(hideSnackbar());
            }, 5000);
            setProductData(res?.data?.data);
            dispatch(
              getProductTypeList({
                callback: (resp: any) => {
                  setProductTypeList(resp?.data);
                  let tempProductType = resp?.data?.filter(
                    (item: any) =>
                      res?.data?.data?.productTypeId?._id === item?._id,
                  );
                  setProductType(tempProductType[0]);
                },
                errorCallback: () => { },
              }),
            );
            const postData = {
              productTypeId: res?.data?.data?.productTypeId?._id,
            };
            dispatch(
              getCategoryList({
                params: postData,
                callback: (respo: any) => {
                  setCategoryList(respo);
                  let tempCategory = respo?.filter(
                    (item: any) =>
                      res?.data?.data?.categoryId?._id === item?._id,
                  );
                  setCategory(tempCategory[0]);
                },
                errorCallback: (error: any) => { },
              }),
            );
            dispatch(
              getAgeGroupList({
                callback: (response: any) => {
                  let tempAgeGrp = response?.data?.map((item: any) => ({
                    ...item,
                    isChecked: res?.data?.data?.ageGroupId.some(
                      (itm: any) => itm?._id === item?._id,
                    ),
                  }));
                  setAgeGroupList(tempAgeGrp);
                },
                errorCallback: () => { },
              }),
            );
            dispatch(
              getLanguageList({
                callback: (data: any) => {
                  setLanguageList(data?.data);
                  // let tempLanguage = data?.data?.filter(
                  //   (item: any) => res?.data?.data?.languageId === item?._id
                  // );
                  // setLanguage(tempLanguage[0]);
                },
                errorCallback: () => { },
              }),
            );
            dispatch(
              getGSTList({
                callback: (req: any) => {
                  setGSTList(req?.data);
                  let tempGst = req?.data?.filter(
                    (item: any) =>
                      res?.data?.data?.GSTPercentage === item?.percentage,
                  );
                  setGSTPercentage(tempGst[0]);
                },
                errorCallback: () => { },
              }),
            );
            setProductId(res?.data?.data?._id);
            setProductType(res?.data?.data?.productTypeId);
            setProductName(res?.data?.data?.name);
            setInitialAge(res?.data?.data?.age);
            setSellingPrice(res?.data?.data?.sellingPrice);
            setOfferPrice(res?.data?.data?.offerPrice);
            setStockReminder(res?.data?.data?.stockReminder);
            setisbnNo(res?.data?.data?.barcodeUrl);
            setUniqueNo(res?.data?.data?.uniqueNo);
            setLanguage(res?.data?.data?.languageId);
            setdiamension(res?.data?.data?.diamension);
            settotalpages(res?.data?.data?.pages);
            setisTaxable(res?.data?.data?.isTaxable);
            setSelectedBuyProduct(res?.data?.data?.buyTogether);
            setimgVideoArr(res?.data?.data?.file);
            setAnswerKeyURL(res?.data?.data?.answerKey);

            const newArrCopy = res?.data?.data?.sourcePrice?.map(
              (item: any) => {
                return {
                  _id: item?.sourceId,
                  name: item?.sourceName,
                  price: item?.price !== undefined ? item.price.toString() : "",
                  isChecked: true,
                };
              },
            );
            newArrCopy?.some((item: any) => {
              if (item?.price !== "") {
                setAllCheck(true);
                setSourcePrice(item?.price);
              }
            });
            setSellingSourceCopy(newArrCopy);

            dispatch(
              getSellingSource({
                callback: (sourceRes: any) => {
                  const baseList =
                    sourceRes?.data?.map((srcItem: any) => ({
                      _id: srcItem?._id,
                      name: srcItem?.name,
                      price: "",
                      isChecked: false,
                    })) || [];

                  const updatedArr = baseList.map((item: any) => {
                    const match = res?.data?.data?.sourcePrice?.find(
                      (c: any) => c && String(c.sourceId) === String(item._id),
                    );
                    if (match) {
                      return {
                        ...item,
                        name: match.sourceName || item.name,
                        price:
                          match.price !== undefined
                            ? match.price.toString()
                            : "",
                        isChecked: true,
                      };
                    }

                    return item;
                  });

                  setSellingSource(updatedArr);
                },
                errorCallback: () => { },
              }),
            );

            dispatch(
              getTagOptionList({
                callback: (response: any) => {
                  const updatedData = response?.data?.map((item: any) => ({
                    ...item,
                    isSelected: res?.data?.data?.tags.some(
                      (data: any) => data._id === item._id,
                    ),
                  }));
                  const productTagIds =
                    res?.data?.data?.tags?.map((val: any) => val._id) || [];
                  setNewTagArr(productTagIds);
                  setTagOptionList(updatedData);
                },
                errorCallback: () => { },
              }),
            );
            setBriefDesc(res?.data?.data?.briefDescription);
            setProductDesc(res?.data?.data?.productDescription);
            setAdditionInfo(res?.data?.data?.additionalInfo);
            setdescriptionImages(res?.data?.data?.descriptionImages);
            setVideo(res?.data?.data?.video);
          }
        },
        errorCallback: (error: any) => { },
      }),
    );
  };
  const handleDelete = (value: any) => {
    setisEditMode(false);
    dispatch(
      deleteProduct({
        id: value._id,
        callback: (res: any) => {
          getData();
          if (res?.status === "success") {
            setisEditMode(false);
            dispatch(showSnackbar({ message: res?.msg, type: res?.status }));
            setTimeout(() => {
              hideSnackbar();
            }, 5000);
          }
        },
        errorCallback: (error: any) => {
          dispatch(
            showSnackbar({
              message: error?.data?.msg,
              type: error?.data?.type,
            }),
          );
          setTimeout(() => {
            hideSnackbar();
          }, 5000);
        },
      }),
    );
  };

  const renderTable = () => {
    return (
      <div className="row bxshadow p-2 borderRadius mb-3">
        <AdminTable
          tableData={productList ? productList : []}
          pagename={"Product"}
          tableHead={["S.N", "Product Name", "Action"]}
          handleEdit={(value: any) => handleEdit(value)}
          handleDelete={(value: any) => handleDelete(value)}
          edit={true}
        />
      </div>
    );
  };

  const onPressAdd = () => {
    setimgVideoArr([...imgVideoArr, initialVal[0]]);
  };
  const handleClose = (index: any) => {
    const newArray = [...imgVideoArr];
    if (index > -1) {
      newArray.splice(index, 1);
    }
    setimgVideoArr(newArray);
  };

  const onchangeProductType = (value: any) => {
    setProductType(value);
    const postData = {
      productTypeId: value?._id,
    };
    dispatch(
      getCategoryList({
        params: postData,
        callback: (res: any) => {
          setCategoryList(res);
        },
        errorCallback: (error: any) => { },
      }),
    );
  };

  const onchangeProductTypeSearch = (value: any) => {
    setProductTypeFilter(value);
    const postData = {
      productTypeId: value?._id,
    };
    dispatch(
      getCategoryList({
        params: postData,
        callback: (res: any) => {
          setCategoryList(res);
        },
        errorCallback: (error: any) => { },
      }),
    );
  };

  const onchangeCategory = (value: any) => {
    setCategory(value);
  };
  const onchangeInitialAge = (value: any) => {
    setInitialAge(value);
  };
  const onchangeProductName = (value: any) => {
    setProductName(value);
  };
  const onchangeBuyTogatherProduct = (value: any, action: any) => {
    if (action === "add") {
      setBuyTogatherProduct(value);
      setSelectedBuyProduct((prev: any) => {
        const alreadyExists = prev?.some(
          (item: any) => item?.name === value?.name,
        );
        if (alreadyExists) {
          dispatch(
            showSnackbar({ message: "Already selected", type: "error" }),
          );
          setTimeout(() => {
            hideSnackbar();
          }, 5000);
          return prev;
        }
        return [...prev, value];
      });
    } else if (action === "remove") {
      setSelectedBuyProduct((prev: any) =>
        prev.filter((item: any) => item?._id !== value?._id),
      );
    }
  };
  const onchangeCategorySearch = (value: any) => {
    setCategoryFilter(value);
    const postData = {
      productTypeId: productTypeFilter?._id,
      categoryId: value?._id,
    };
    dispatch(
      getProductList({
        params: postData,
        callback: (res: any) => {
          setProductList(res);
        },
        errorCallback: (error: any) => { },
      }),
    );
  };

  // const onchangeAgeGrp = (value: any) => {
  //   setAgeGroup(value);
  // };
  const oncheckAgeGrp = (val: any, key: string, index: number, item: any) => {
    const newArr = JSON.parse(JSON.stringify(ageGroupList));
    if (key === "isChecked") {
      newArr[index][key] = val?.target?.checked;
      setAgeGroupList(newArr);
    } else {
      const value = val.target.value.replace(/\D/g, "");
      newArr[index][key] = value;
      setAgeGroupList(newArr);
    }
  };

  const onchnageSellingPrice = (value: any) => {
    if (value !== "") {
      if (!containsNumber(value)) {
        return;
      } else if (!validateValueWithoutSpace(value)) {
        return;
      } else {
        setSellingPrice(value);
      }
    } else {
      setSellingPrice(value);
    }
  };
  const onchnageOfferPrice = (value: any) => {
    const offerPrice = Number(value);
    const sellPrice = Number(sellingPrice);
    if (value !== "") {
      if (!containsNumber(value)) {
        return;
      } else if (!validateValueWithoutSpace(value)) {
        return;
      } else if (offerPrice > sellPrice) {
        dispatch(
          showSnackbar({
            message:
              "Please Enter valid Offer pirce!!, Offer Price shoould not be greater than Selling Price",
            type: "error",
          }),
        );
        setTimeout(() => {
          hideSnackbar();
        }, 5000);
        return;
      } else {
        setOfferPrice(value);
      }
    } else {
      setOfferPrice(value);
    }
  };
  const onchaangeStockReminder = (value: any) => {
    if (value !== "") {
      if (!containsNumber(value)) {
        return;
      } else if (!validateValueWithoutSpace(value)) {
        return;
      } else {
        setStockReminder(value);
      }
    } else {
      setStockReminder(value);
    }
  };
  const onchangeIsbnNo = (value: any) => {
    if (value !== "") {
      if (!containsNumber(value)) {
        return;
      } else if (!validateValueWithoutSpace(value)) {
        return;
      } else {
        if (value?.length < length_Thirteen) {
          setisbnNo(value);
        }
      }
    } else {
      setisbnNo(value);
    }
  };
  const onchangeUniqueNo = (value: any) => {
    if (value !== "") {
      if (!containsNumber(value)) {
        return;
      } else if (!validateValueWithoutSpace(value)) {
        return;
      } else {
        if (value?.length < length_Thirteen) {
          setUniqueNo(value);
        }
      }
    } else {
      setUniqueNo(value);
    }
  };

  const onchangeLanguage = (value: any) => {
    setLanguage(value);
  };
  const onchangeDaimension = (value: any) => {
    setdiamension(value);
    // if (value !== "") {
    //   if (!validateDimension(value)) {
    //     return;
    //   } else if (!validateValueWithoutSpace(value)) {
    //     return;
    //   } else {
    //     setdiamension(value);
    //   }
    // } else {
    //   setdiamension(value);
    // }
  };
  const handleAllCheck = (value: any) => {
    let newArray = JSON.parse(JSON.stringify(sellingSource));
    if (value.target.checked) {
      newArray.map((item: any) => {
        Object.assign(item, { isChecked: value.target.checked });
        setAllCheck(value.target.checked);
        return item;
      });
    } else {
      newArray.map((item: any) => {
        Object.assign(item, {
          isChecked: value.target.checked,
          price: "",
        });
        setAllCheck(value.target.checked);
        setSourcePrice("");
        return item;
      });
    }
    setSellingSource(newArray);
    setSellingSourceCopy(newArray);
  };
  const handleSourcePrice = (value: any) => {
    const val = value.replace(/\D/g, "");
    if (allCheck) {
      const newArr = JSON.parse(JSON.stringify(sellingSource));
      newArr.map((item: any) => {
        Object.assign(item, { price: val });
        setSourcePrice(item?.price);
        return item;
      });
      setSellingSource(newArr);
      setSellingSourceCopy(newArr);
    } else {
      setSourcePrice(val);
    }
  };

  const onChangeSellingSource = (
    val: any,
    key: string,
    index: number,
    item: any,
  ) => {
    const newArr = JSON.parse(JSON.stringify(sellingSource));
    const newArrCopy = JSON.parse(JSON.stringify(sellingSourceCopy));
    if (key === "isChecked") {
      const isChecked = val?.target?.checked;
      newArr[index][key] = isChecked;
      const existingIndex = newArrCopy.findIndex(
        (i: any) => i._id === item._id,
      );
      if (isChecked && existingIndex === -1) {
        newArrCopy.splice(index, 0, { ...item, isChecked: true });
      } else if (!isChecked && existingIndex !== -1) {
        newArrCopy.splice(existingIndex, 1);
      }
      setSellingSource(newArr);
      setSellingSourceCopy(newArrCopy);
    } else {
      const value = val.target.value.replace(/\D/g, "");
      newArr[index][key] = value;
      const copyIndex = newArrCopy.findIndex((i: any) => i._id === item._id);
      if (copyIndex !== -1) {
        newArrCopy[copyIndex][key] = value;
      }
      setSellingSource(newArr);
      setSellingSourceCopy(newArrCopy);
    }
  };

  const onchangeBriefDesc = (value: any) => {
    setBriefDesc(value);
  };
  const onchangeProductDesc = (value: any) => {
    setProductDesc(value);
  };
  const onchangeAdditionInfo = (value: any) => {
    setAdditionInfo(value);
  };

  const handleProductVideo = (value: any) => {
    if (!validateIsFileVideoType(value)) {
      return;
    } else {
      const reader = new FileReader();
      const file = value.target.files[0];
      reader.onloadend = () => {
        setVideoPreview(reader.result);
      };
      reader.readAsDataURL(file);
      const imagePayload = {
        file: file,
        type: "description",
        format: "2",
      };
      dispatch(
        uploadMedia({
          params: imagePayload,
          callback: (res: any) => {
            if (res?.data) {
              setVideo(res?.data?.name);
            }
          },
          errorCallback: () => { },
        }),
      );
    }
  };

  const onchangeProductImage = (
    value: any,
    index: any,
    key: any,
    doctype: any,
  ) => {
    // const newArray = [...descriptionImages];
    if (key === "image" && doctype === "image") {
      if (!validateIsFileImageType(value)) return;
      const file = value.target.files[0];
      const reader = new FileReader();
      reader.onloadend = () => {
        setdescriptionImages((prev: any) => {
          const updated = [...prev];
          updated[index] = {
            ...updated[index],
            imagePreview: reader.result as string,
          };
          return updated;
        });
      };
      reader.readAsDataURL(file);

      const imagePayload = {
        file,
        type: "description",
        format: "1",
      };

      dispatch(
        uploadMedia({
          params: imagePayload,
          callback: (res: any) => {
            if (res?.data) {
              setdescriptionImages((prev: any) => {
                const updated = [...prev];
                updated[index] = {
                  ...updated[index],
                  [key]: res.data.name,
                };
                return updated;
              });
            }
          },
          errorCallback: () => { },
        }),
      );
    } else {
      setdescriptionImages((prev: any) => {
        const updated = [...prev];
        updated[index] = {
          ...updated[index],
          [key]: value,
        };
        return updated;
      });
    }
    // else if (key === "text") {
    //   newArray[index][key] = value;
    //   setdescriptionImages(newArray);
    // }
  };

  const handleCloseAddProductImg = (index: any) => {
    setdescriptionImages((prev: any) =>
      prev.filter((_: any, i: number) => i !== index),
    );
  };

  const onPressAddProductImg = () => {
    setdescriptionImages((prev: any) => [
      ...prev,
      {
        image: "",
        order: "",
        text: "",
        type: 1,
        imagePreview: "",
      },
    ]);
  };
  const getFileNameFromUrl = (url: string) => {
    if (!url) return "";
    if (!url.includes("/")) {
      return url;
    }
    return url.split("/").pop() || "";
  };

  const handleSubmit = (e: any) => {
    e.preventDefault();
    const updatedProdescImg = productData?.descriptionImages.map(
      (item: any) => {
        const match = item.image?.match(/[^/]+$/);
        const filename = match ? match[0] : "";
        const { _id, ...rest } = item;
        return { ...rest, image: filename };
      },
    );
    const updatedDescriptionImages = descriptionImages.map((item: any) => {
      const match = item.image?.match(/[^/]+$/);
      const filename = match ? match[0] : "";
      const { imagePreview, _id, ...rest } = item;
      return { ...rest, image: filename };
    });
    const updatedFileImages = imgVideoArr.map((item: any) => {
      const { imagePrevUrl, _id, value, ...rest } = item;
      return rest;
    });
    // The above two functions are just to compare old value to new one with same kye value pair
    const postData: any = {};
    if (productData?.name !== productName) {
      postData["name"] = productName;
    }
    if (
      productData?.productTypeId?._id !== productType?._id ||
      productData?.name !== productName
    ) {
      postData["productTypeId"] = productType?._id;
    }
    if (
      productData?.categoryId?._id !== category?._id ||
      productData?.name !== productName
    ) {
      postData["categoryId"] = category?._id;
    }
    if (initialAge) {
      postData["age"] = initialAge;
    }
    const ageGroupId = ageGroupList?.filter(
      (item: any) => item?.isChecked === true,
    );
    // const prevAgeGroupIds = productData?.ageGroupId?.map((item: any) => item._id);
    // const isNameChanged = productData?.name !== productName;

    // if (prevAgeGroupIds.length > 0 && isNameChanged) {
    //   postData.ageGroupId = prevAgeGroupIds;
    // }
    if (ageGroupId?.length > 0) {
      const arr = ageGroupId?.map((item: any) => item?._id);
      postData["ageGroupId"] = arr;
    }
    if (productData?.sellingPrice !== sellingPrice) {
      postData["sellingPrice"] = sellingPrice;
    }
    if (productData?.offerPrice !== offerPrice) {
      postData["offerPrice"] = offerPrice;
    }
    if (productData?.stockReminder !== stockReminder) {
      postData["stockReminder"] = stockReminder;
    }
    if (productData?.uniqueNo !== uniqueNo) {
      postData["uniqueNo"] = uniqueNo;
    }
    if (selectedBuyProduct?.length > 0) {
      const arr = selectedBuyProduct?.map((item: any) => item?._id);
      postData["buyTogether"] = arr;
    }
    if (productData?.briefDescription !== briefDesc) {
      postData["briefDescription"] = briefDesc;
    }
    if (productData?.productDescription !== productDesc) {
      postData["productDescription"] = productDesc;
    }
    if (productData?.additionalInfo !== additionInfo) {
      postData["additionalInfo"] = additionInfo;
    }
    if (productData?.tags?.[0]?._id !== newTagArr?.[0]) {
      postData["tags"] = [newTagArr[0]];
    }
    if (productData?.file !== updatedFileImages) {
      postData["file"] = updatedFileImages.map((item: any) => ({
        ...item,
        url: getFileNameFromUrl(item.url),
      }));
    }
    if (productData?.languageId?._id !== language?._id) {
      postData["languageId"] = language?._id;
    }
    if (productData?.isTaxable !== isTaxable) {
      postData["isTaxable"] = isTaxable;
    }
    if (
      JSON.stringify(updatedProdescImg) !==
      JSON.stringify(updatedDescriptionImages)
    ) {
      postData["descriptionImages"] = updatedDescriptionImages;
    }
    if (productData?.diamension !== diamension) {
      postData["diamension"] = diamension;
    }
    if (productData?.pages !== totalpages) {
      postData["pages"] = totalpages;
    }
    if (productData?.video !== video) {
      postData["video"] = video;
    }
    if (
      JSON.stringify(productData?.sourcePrice) !==
      JSON.stringify(sellingSourceCopy)
    ) {
      const newArr = sellingSource?.filter(
        (item: any) => item?.isChecked === true,
      );
      if (newArr?.length > 0) {
        const arr = newArr?.map((item: any) => {
          return {
            sourceId: item?._id,
            sourceName: item?.name,
            price: item?.price,
          };
        });
        postData["sourcePrice"] = arr;
      }
      if (productData?.answerKey !== answerKeyURL) {
        postData["answerKey"] = answerKeyURL;
      }
    }
    if (Object.keys(postData).length === 0) {
      dispatch(
        showSnackbar({
          message:
            "Same old Data can not Be Update!! Please edit the old data to Update.",
          type: "error",
        }),
      );
      setTimeout(() => {
        dispatch(hideSnackbar());
      }, 5000);
    } else {
      dispatch(
        updateProduct({
          id: productId,
          params: postData,
          callback: (res: any) => {
            if (res?.data?.status === "success") {
              setisEditMode(false);
              setProductName("");
              setProductType("");
              setCategory("");
              setAgeGroup("");
              setSellingPrice("");
              setOfferPrice("");
              setStockReminder("");
              setisbnNo("");
              setUniqueNo("");
              setIsEditingIsbn(false);
              setBriefDesc("");
              setProductDesc("");
              setAdditionInfo("");
              setNewTagArr([]);
              setimgVideoArr(initialVal);
              setLanguage("");
              setdiamension("");
              setLanguage("");
              settotalpages("");
              setGSTPercentage("");
              setVideo("");
              setVideoPreview("");
              setdescriptionImages(initialValDescImg);
              setInitialAge("");
              setBuyTogatherProduct("");
              setSelectedBuyProduct([]);
              setAllCheck(false);
              setSourcePrice("");
              setAnswerKeyURL("");
              // Reset the selling-source section back to a clean, fully
              // unchecked master list (instead of wiping to []), so the next
              // handleEdit / validations() call always has real data to work
              // with even before its own fresh fetch completes.
              setSellingSource((prev: any) =>
                (prev || []).map((item: any) => ({
                  ...item,
                  isChecked: false,
                  price: "",
                })),
              );
              setSellingSourceCopy([]);
              dispatch(
                showSnackbar({
                  message: res?.data?.msg,
                  type: res?.data?.status,
                }),
              );
              setTimeout(() => {
                hideSnackbar();
              }, 5000);
            }
          },
          errorCallback: (error: any) => {
            dispatch(
              showSnackbar({
                message: error?.data?.msg,
                type: error?.data?.status,
              }),
            );
            setTimeout(() => {
              hideSnackbar();
            }, 5000);
          },
        }),
      );
    }
  };
  const handleGoBack = () => {
    setisEditMode(false);
  };

  const isEditorEmpty = (html: string = ""): boolean => {
    const temp = document.createElement("div");
    temp.innerHTML = html;

    const text = (temp.textContent ?? "").replace(/\u00A0/g, "").trim();

    return text.length === 0;
  };
  const validations = () => {
    let valid = false;
    imgVideoArr.map((item: any) => {
      if (item?.url === "" || item?.order === "") {
        valid = true;
      }
    });
    descriptionImages.map((data: any) => {
      if (
        data?.image === "" ||
        data?.order === "" ||
        isEditorEmpty(data?.text)
      ) {
        valid = true;
      }
    });
    let isSellingSourse = sellingSource.some(
      (item: any) => item?.isChecked === true && item?.price !== "",
    );

    if (productType === "") {
      valid = true;
    }
    if (category === "") {
      valid = true;
    }
    if (productName === "") {
      valid = true;
    }
    if (initialAge === "") {
      valid = true;
    }
    if (!(ageGroupList?.length > 0)) {
      valid = true;
    }
    if (sellingPrice === "") {
      valid = true;
    }
    if (offerPrice === "") {
      valid = true;
    }
    if (isbnNo === "") {
      valid = true;
    }
    if (!isSellingSourse) {
      valid = true;
    }
    // if (briefDesc === "") {
    //   valid = true;
    // }
    // if (productDesc === "") {
    //   valid = true;
    // }

    return valid;
  };
  const onchangeAnswerKeyPdf = (e: any) => {
    const file = e?.target?.files?.[0];

    if (!file) return;

    if (file.type !== "application/pdf") {
      dispatch(
        showSnackbar({
          message: "Please upload only PDF file",
          type: "error",
        }),
      );
      setTimeout(() => {
        dispatch(hideSnackbar())
      }, 5000);
      e.target.value = "";
      return;
    }
    // const MAX_FILE_SIZE = 50 * 1024 * 1024;
    // if (file.size > MAX_FILE_SIZE) {
    //   dispatch(
    //     showSnackbar({
    //       message: "PDF file size should not exceed 50 MB",
    //       type: "error",
    //     }),
    //   );
    //   setTimeout(() => {
    //     dispatch(hideSnackbar())
    //   }, 5000);
    //   e.target.value = "";
    //   return;
    // }

    dispatch(
      booksAnswerkeyUpload({
        params: file,
        callback: (res: any) => {
          if (res?.status === "success") {
            setAnswerKeyURL(res?.data?.name);
          }
        },

        errorCallback: (error: any) => {
          dispatch(
            showSnackbar({
              message: error?.message || "PDF upload failed",
              type: "error",
            }),
          );
          setTimeout(() => {
            dispatch(hideSnackbar())
          }, 5000);
        },
      }),
    );
  };
  const renderEditMode = () => {
    return (
      <form onSubmit={handleSubmit}>
        <div className="row bxshadow p-2 borderRadius mb-3">
          <div className="col-md-4 mb-3">
            <LabelInput labelName={"Product type"} isRequired />
            <DropdownWithClear
              labelName={"Select Product type"}
              setInputText={(value: any) => onchangeProductType(value)}
              options={productTypeList}
              value={productType}
            />
          </div>
          <div className="col-md-4 mb-3">
            <LabelInput labelName={"Product category "} isRequired />
            <DropdownWithClear
              labelName={"Select Product category "}
              setInputText={(value: any) => onchangeCategory(value)}
              options={categoryList}
              value={category}
            />
          </div>
          <div className="col-md-4 mb-3">
            <LabelInput labelName={"Initial Age "} isRequired />
            <InputField
              key={"ex2"}
              placeholder={"Enter Initial Age (0-2)"}
              setInputText={(value: any) => onchangeInitialAge(value)}
              value={initialAge}
            />
          </div>
          <div className="col-md-4 mb-3">
            <LabelInput labelName={"Age group"} isRequired />
            <div className="ageGroupcheckbox d-flex align-items center p-2">
              {ageGroupList?.map((item: any, index: number) => (
                <>
                  <input
                    className="check me-1"
                    type="checkbox"
                    value={item?.isChecked}
                    checked={item?.isChecked}
                    id={`defaultCheck${item?._id}`}
                    onChange={(value) => {
                      oncheckAgeGrp(value, "isChecked", index, item);
                    }}
                  />
                  <span className="checkVal me-3">{item?.name}</span>
                </>
              ))}
            </div>
            {/* <DropdownWithClear
              labelName={"Select Age group"}
              setInputText={(value: any) => onchangeAgeGrp(value)}
              options={ageGroupList}
              value={ageGroup}
            /> */}
          </div>
          <div className="col-md-4 mb-3">
            <LabelInput labelName={"Product name "} isRequired />
            <InputField
              key={"ex2"}
              placeholder={"Enter Product name "}
              setInputText={(value: any) => onchangeProductName(value)}
              value={productName}
            />
          </div>
          <div className="col-md-4 mb-3">
            <LabelInput labelName={"selling price"} isRequired />
            <InputField
              key={"ex2"}
              placeholder={"Enter selling price"}
              setInputText={(value: any) => onchnageSellingPrice(value)}
              value={sellingPrice}
            />
          </div>
          <div className="col-md-4 mb-3">
            <LabelInput labelName={"offer price "} isRequired />
            <InputField
              key={"ex2"}
              placeholder={"Enter offer price "}
              setInputText={(value: any) => onchnageOfferPrice(value)}
              value={offerPrice}
            />
          </div>

          <div className="col-md-4 mb-3">
            <LabelInput labelName={"Stock Reminder "} />
            <InputField
              key={"ex2"}
              placeholder={"Enter Stock Reminder "}
              setInputText={(value: any) => onchaangeStockReminder(value)}
              value={stockReminder}
            />
          </div>
          <div className="col-md-4 mb-3 ">
            <div className="d-flex align-items-center justify-content-between">
              <LabelInput labelName={"ISBN Number"} isRequired />
              {!isEditingIsbn && (
                <EditIcon
                  className="cursor text-primary mb-2"
                  fontSize="small"
                  onClick={() => setIsEditingIsbn(true)}
                />
              )}
            </div>
            {isEditingIsbn ? (
              <InputField
                placeholder={"Enter ISBN Number"}
                setInputText={(value: any) => onchangeUniqueNo(value)}
                value={uniqueNo}
                maxLength={length_Thirteen}
              />
            ) : (
              <img src={isbnNo} className="img-fluid d-block col-6"></img>
            )}
          </div>
          <div className="col-md-4 mb-3">
            <LabelInput labelName={"Language"} />
            <DropdownWithClear
              labelName={"Select Language"}
              setInputText={(value: any) => onchangeLanguage(value)}
              options={languageList}
              value={language}
            />
          </div>

          <div className="col-md-4 mb-3">
            <LabelInput labelName={"Dimensions"} />
            <InputField
              placeholder={"Enter Dimensions"}
              setInputText={(value: any) => onchangeDaimension(value)}
              value={diamension}
            />
          </div>
          <div className="col-md-4 mb-3">
            <LabelInput labelName={"Total pages"} />
            <InputField
              placeholder={"Enter total pages"}
              setInputText={(value: any) => settotalpages(value)}
              value={totalpages}
              maxLength={length_Four}
            />
          </div>
          <div className="col-md-4 mb-3">
            <LabelInput labelName={"Is Taxable"} />
            <div>
              <span className="fw-bold">
                <input
                  type="radio"
                  value="true"
                  name="isTaxable"
                  checked={isTaxable ? true : false}
                  onChange={() => setisTaxable(true)}
                />{" "}
                Yes
              </span>
              <span className="fw-bold ms-3">
                <input
                  type="radio"
                  value="false"
                  name="isTaxable"
                  checked={!isTaxable ? true : false}
                  onChange={() => setisTaxable(false)}
                />{" "}
                No
              </span>
            </div>
          </div>
          {isTaxable ? (
            <div className="col-md-4 mb-3">
              <LabelInput labelName={"GST Percentage"} />
              <DropdownWithClear
                labelName={"Select GST Percentage"}
                setInputText={(value: any) => setGSTPercentage(value)}
                options={GSTList}
                value={GSTPercentage}
              />
            </div>
          ) : null}
          <div className="col-md-4 mb-3">
            <LabelInput labelName={"Answer Key PDF File"} />
            <div className="d-flex align-items-center gap-2">
              <ImagePickerAndViewer
                value={answerKeyURL}
                handleChange={onchangeAnswerKeyPdf}
                htmlFor="answer-key-pdf-upload"
                doctype="pdf"
              />
              {answerKeyURL && (
                <div
                  className="text-success small text-break"
                  style={{ maxWidth: "320px" }}
                >
                  ✓ {answerKeyURL} uploaded successfully
                </div>
              )}
            </div>
          </div>
          {productData?.answerkeyQR && (
            <div className="col-md-4 mb-3">
              <LabelInput labelName={"Answer Key QR Code"} />

              <div className="d-flex align-items-end gap-2">
                <img
                  src={productData.answerkeyQR}
                  alt="Answer Key QR Code"
                  style={{
                    width: "120px",
                    height: "120px",
                    objectFit: "contain",
                    padding: "5px",
                    background: "#fff",
                    border: "1px solid #e5e7eb",
                    borderRadius: "12px",
                    boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
                  }}
                />

                <Tooltip title="Download Answer Key QR Code">
                  <button
                    type="button"
                    className="d-flex align-items-center gap-2"
                    style={{
                      background: "#244394",
                      color: "#fff",
                      border: "none",
                      borderRadius: "10px",
                      padding: "8px 16px",
                      fontSize: "14px",
                      fontWeight: "600",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      const link = document.createElement("a");
                      link.href = productData.answerkeyQR;
                      link.download = "Answer-Key-QR-Code.png";
                      document.body.appendChild(link);
                      link.click();
                      document.body.removeChild(link);
                    }}
                  >
                    <DownloadIcon fontSize="small" />
                    Download QR
                  </button>
                </Tooltip>
              </div>
            </div>
          )}
        </div>
        <div className="row bxshadow p-2 borderRadius mb-3">
          <div className="col-md-4 mb-3">
            <LabelInput labelName={"Buy Togather Product"} />
            <DropdownWithClear
              labelName={"Select Buy Togather Product"}
              setInputText={(value: any) =>
                onchangeBuyTogatherProduct(value, "add")
              }
              options={productList}
              value={buyTogatherProduct}
            />
          </div>
          {selectedBuyProduct?.length > 0 && (
            <div className="col-md-8 mb-3">
              <LabelInput labelName={"Selected Buy Togather Product"} />
              <div className="d-flex flex-wrap">
                {selectedBuyProduct.map((item: any, index: any) => {
                  return (
                    <div key={index} className="me-3 mb-3">
                      <span className="badge bg-secondary position-relative colorTheme1 font12">
                        {item?.name}
                        <span
                          className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger"
                          onClick={() =>
                            onchangeBuyTogatherProduct(item, "remove")
                          }
                        >
                          X
                        </span>
                      </span>
                    </div>
                  );
                })}
              </div>
            </div>
          )}
        </div>
        <div className="row bxshadow p-2 borderRadius mb-3">
          <div className="mb-3">
            <LabelInput labelName={"Selling Source"} isRequired />
          </div>
          <div className="">
            <div className="col-md-6 d-flex justify-content-start align-items-center mb-3">
              <div className="d-flex e-input align-items-center mx-2 mb-3">
                <input
                  className="check"
                  type="checkbox"
                  checked={allCheck}
                  onChange={(value) => {
                    handleAllCheck(value);
                  }}
                />
                <span className="checkVal ms-2">
                  <b>Check All</b>
                </span>
              </div>
              <div className="">
                <InputField
                  placeholder={"Enter Price"}
                  value={sourcePrice}
                  setInputText={(value: any) => handleSourcePrice(value)}
                  disabled={!allCheck}
                  maxLength={5}
                />
              </div>
            </div>
            <div className="row">
              {sellingSource?.map((item: any, index: any) => {
                return (
                  <div className="col-md-4 mb-3" key={index}>
                    <div className="d-flex justify-content-between bxshadow p-2 borderRadius">
                      <div>
                        <LabelInput labelName={"Source"} />
                        <div className="d-flex e-input align-items-center me-3">
                          <input
                            className="check"
                            type="checkbox"
                            value={item?.isChecked}
                            checked={item?.isChecked}
                            id={`defaultCheck${item?._id}`}
                            onChange={(val) =>
                              onChangeSellingSource(
                                val,
                                "isChecked",
                                index,
                                item,
                              )
                            }
                          />
                          <span className="checkVal ms-2">{item?.name}</span>
                        </div>
                      </div>
                      <div className="col-6">
                        <LabelInput labelName={"Price"} />
                        <input
                          type="text"
                          className="form-control"
                          placeholder={"Enter Price"}
                          onChange={(val: any) =>
                            onChangeSellingSource(val, "price", index, item)
                          }
                          value={item?.price}
                          maxLength={5}
                          disabled={!item?.isChecked}
                        />
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
        <div className="mb-3">
          <LabelInput labelName={"Upload Images/video"} isRequired />
          <div className="row g-5">
            {imgVideoArr.map((item: any, index: any) => {
              const { url, order, type, imagePrevUrl } = item;
              return (
                <div className="col-md-6 mb-3">
                  <div
                    className="row bxshadow p-2 borderRadius position-relative"
                    key={index}
                  >
                    <div className="col-md-7 mb-3">
                      <div className="row">
                        <div className="col-md-4 mb-2">
                          <span className="fw-bold">
                            <input
                              type="radio"
                              value={1}
                              name={"type" + index}
                              checked={type === 1 ? true : false}
                              onChange={() =>
                                onchangeImgVideo(1, index, "type", " ")
                              }
                            />{" "}
                            Image
                          </span>
                        </div>
                        <div className="col-md-4 mb-2">
                          <span className="fw-bold">
                            <input
                              type="radio"
                              value={2}
                              name={"type" + index}
                              checked={type === 2 ? true : false}
                              onChange={() =>
                                onchangeImgVideo(2, index, "type", " ")
                              }
                            />{" "}
                            Video
                          </span>
                        </div>
                      </div>
                      <div className="col-md-6">
                        {type === 1 ? (
                          <ImgPickerAndViewer
                            value={imagePrevUrl ? imagePrevUrl : url}
                            handleChange={(value: any) =>
                              onchangeImgVideo(value, index, "url", "image")
                            }
                          />
                        ) : type === 2 ? (
                          // <ImgPickerAndViewer
                          //   value={url}
                          //   handleChange={(value: any) =>
                          //     onchangeImgVideo(value, index, "url", "video")
                          //   }
                          //   doctype={"video"}
                          // />
                          <div className="d-flex">
                            <ImagePickerAndViewer
                              value={url}
                              handleChange={(value: any) =>
                                onchangeImgVideo(value, index, "url", "video")
                              }
                              htmlFor={`video-upload-${index}`}
                              doctype={"video"}
                            />
                            {url ? (
                              <div className="video-thumbnail-holder">
                                <video
                                  ref={videoRef}
                                  className="videoClass"
                                  controls
                                  style={{
                                    width: "150px",
                                    height: "100px",
                                  }}
                                >
                                  <source
                                    src={imagePrevUrl ? imagePrevUrl : url}
                                    type="video/mp4"
                                  />
                                  <source src="movie.ogg" type="video/ogg" />
                                  Your browser does not support the video tag.
                                </video>
                              </div>
                            ) : (
                              ""
                            )}
                          </div>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                    <div className="col-md-4 mb-3">
                      <LabelInput labelName={"Order number"} />
                      <InputField
                        placeholder={`Order  No. ${index + 1}`}
                        setInputText={(value: any) =>
                          onchangeImgVideo(value, index, "order", "")
                        }
                        value={order}
                      />
                    </div>
                    {imgVideoArr?.length != 1 ? (
                      <div className="col-1 position-absolute end-0">
                        <DeleteForeverIcon
                          className="text-danger cursor"
                          onClick={() => handleClose(index)}
                        />
                      </div>
                    ) : (
                      ""
                    )}
                    {index === imgVideoArr.length - 1 && (
                      <div
                        className=""
                        style={{
                          width: "135px",
                          position: "absolute",
                          bottom: "5%",
                          right: "0%",
                        }}
                      >
                        <AddMoreBtn handleClick={onPressAdd} />
                      </div>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
        <div className="row bxshadow p-2 borderRadius mb-4 w-50">
          <LabelInput labelName={"Tag Option"} />
          {tagOptionList.map((item: any, index: any) => {
            const { _id, name } = item;
            return (
              <div key={item?._id} className="col-md-4 mb-2">
                <input
                  id={_id}
                  className="check"
                  type="checkbox"
                  value={name}
                  checked={item?.isSelected}
                  onChange={(event: any) => {
                    changeCheckBox(event, index);
                  }}
                />
                <span className="checkVal ms-3">{name}</span>
              </div>
            );
          })}
        </div>
        <div className="row bxshadow p-2 borderRadius mb-4">
          <div className="col-md-6 mb-3">
            <LabelInput labelName={"Brief Description"} />
            <TextEditor
              onChange={(value: any) => onchangeBriefDesc(value)}
              value={briefDesc}
            />
          </div>
          <div className="col-md-6 mb-3">
            <LabelInput labelName={"Product Description"} />
            <TextEditor
              onChange={(value: any) => onchangeProductDesc(value)}
              value={productDesc}
            />
          </div>
          <div className="col-md-6 mb-3">
            <LabelInput labelName={"Addition Info "} />
            <TextEditor
              onChange={(value: any) => onchangeAdditionInfo(value)}
              value={additionInfo}
            />
          </div>
          <div className="col-md-6 mb-3">
            <LabelInput labelName={"Product Video"} />
            {/* <ImgPickerAndViewer
              value={video}
              handleChange={(value: any) => handleProductVideo(value)}
              doctype={"video"}
            /> */}
            <ImagePickerAndViewer
              value={videoPreview ? videoPreview : video}
              handleChange={(value: any) => handleProductVideo(value)}
              htmlFor={`prodict-video-upload`}
              doctype={"video"}
            />
            {videoPreview || video ? (
              <div className="video-thumbnail-holder">
                <video
                  ref={productVideoRef}
                  className="videoClass"
                  controls
                  style={{
                    width: "150px",
                    height: "100px",
                  }}
                >
                  <source
                    src={videoPreview ? videoPreview : video}
                    type="video/mp4"
                  />
                  <source src="movie.ogg" type="video/ogg" />
                  Your browser does not support the video tag.
                </video>
              </div>
            ) : (
              ""
            )}
          </div>
        </div>
        <div className="row g-5">
          {descriptionImages.map((item: any, index: any) => {
            const { image, order, text, imagePreview } = item;
            return (
              <div className="col-md-6" key={index}>
                <div className="row bxshadow p-2 borderRadius position-relative">
                  <div className="col-md-6 mb-3">
                    <LabelInput
                      labelName={"Product Description Images"}
                      isRequired
                    />
                    <ImgPickerAndViewer
                      value={imagePreview ? imagePreview : image}
                      handleChange={(value: any) =>
                        onchangeProductImage(value, index, "image", "image")
                      }
                    />
                  </div>
                  <div className="col-md-6 mb-3">
                    <LabelInput labelName={"Order number"} />
                    <InputField
                      // key={"ex2"}
                      placeholder={`Order  No. ${index + 1}`}
                      setInputText={(value: any) =>
                        onchangeProductImage(value, index, "order", "")
                      }
                      value={order}
                    />
                  </div>
                  <div className="col-md-12">
                    <LabelInput labelName={"Text"} />
                    <TextEditor
                      onChange={(value: any) =>
                        onchangeProductImage(value, index, "text", "")
                      }
                      value={text}
                    />
                  </div>
                  {index === descriptionImages?.length - 1 && (
                    <div className="col-md-3 ms-auto text-end">
                      <AddMoreBtn handleClick={onPressAddProductImg} />
                    </div>
                  )}
                  {descriptionImages?.length === 1 ? (
                    ""
                  ) : (
                    <div className="col-1 position-absolute end-0">
                      <DeleteForeverIcon
                        className="text-danger cursor"
                        onClick={() => handleCloseAddProductImg(index)}
                      />
                    </div>
                  )}
                </div>
              </div>
            );
          })}
        </div>
        <div className="col-md-2 mx-auto my-4">
          <Submitbtn name={"Save"} disabled={validations()} />
        </div>
      </form>
    );
  };
  return (
    <div className="panel-content">
      <div className="mb-4">
        <PageTitle
          name={"Edit / Delete Product"}
          breadCrumb={""}
          isEditMode={isEditMode}
          setisEditMode={setisEditMode}
          cancelEdit={() => handleGoBack()}
        />
      </div>
      <div className="formDiv">
        <div className="">
          {!isEditMode ? (
            <div className="row bxshadow p-2 borderRadius mb-3">
              <div className="col-md-4">
                <LabelInput labelName={"Product Type"} />
                <DropdownWithClear
                  labelName={"Select Product Type"}
                  setInputText={(value: any) =>
                    onchangeProductTypeSearch(value)
                  }
                  options={productTypeList}
                  value={productTypeFilter}
                />
              </div>
              <div className="col-md-4 mb-3">
                <LabelInput labelName={"Product Category"} />
                <DropdownWithClear
                  labelName={"Select Product Category"}
                  setInputText={(value: any) => onchangeCategorySearch(value)}
                  options={categoryList}
                  value={categoryFilter}
                />
              </div>
            </div>
          ) : null}
          {isEditMode ? renderEditMode() : renderTable()}
        </div>
      </div>
    </div>
  );
};

export default EditDeleteProduct;
